import { useAppSelector } from '../../../redux/hook'
import NoOrganizationAccess from '../../Miscellaneous/NoOrganizationAccess'
import RoutesComponent from './RoutesComponent'

/**
 * Content region rendered below the top navbar. Shows the no-organization
 * message for an authenticated "orphan" user (UBQ-5740), otherwise the normal
 * routed application.
 */
const MainContent: React.FC = () => {
    const hasNoOrganizations = useAppSelector(
        (state) => state.org.hasNoOrganizations,
    )

    return hasNoOrganizations ? <NoOrganizationAccess /> : <RoutesComponent />
}

export default MainContent
